import { useEffect, useState } from "react"
import { CashFlowMapping } from "../../../helpers/interfaces"
import { FormEditMode } from "../../../helpers/constants"
import { createGTBClassification as createCashFlowMapping, updateGTBClassification as updateCashFlowMapping } from "../../../apiServices/GTBMappingKeysApi"
import CustomDialog from "../../CustomDialog"
import { CustomTextField } from "../../../layouts/themes"
import { Button } from "@mui/material"
import { Add } from "@mui/icons-material"


interface Props {
    setCashFlowMapping:React.Dispatch<React.SetStateAction<CashFlowMapping[]>>
    cashFlowMapping: CashFlowMapping[]
    openCashFlowMappingForm:boolean
    setFormEditMode:  React.Dispatch<React.SetStateAction<number>>
    setOpenCashFlowMappingForm:React.Dispatch<React.SetStateAction<boolean>>
    cashFlowMappingToEdit:string
    cashFlowMappingEditMode:number
}
function CreateEditCashFlowMapping(props: Props) {
    const [cashFlowMappingName, setCashFlowMappingName] = useState<string>("");
    
    useEffect(() => {
        if (props.cashFlowMappingEditMode === FormEditMode.EDIT) {
            var _cashFlowMappingName = props.cashFlowMapping.find(e => e.id === props.cashFlowMappingToEdit)
            if (!_cashFlowMappingName) return
            setCashFlowMappingName(_cashFlowMappingName.name)
           
        }
    }, [props.cashFlowMapping, props.cashFlowMappingEditMode, props.cashFlowMappingToEdit])

    function createNewCashFlowMapping() {
        createCashFlowMapping(cashFlowMappingName).then(_cfc=> {
            props.setOpenCashFlowMappingForm(false);
            props.setCashFlowMapping(cfc => [...cfc, _cfc])
            
        })
    }
    function updateNewCashFlowMapping() {
        updateCashFlowMapping(props.cashFlowMappingToEdit, cashFlowMappingName).then(result => {
            props.setOpenCashFlowMappingForm(false);
            props.setCashFlowMapping(cfc => cfc.map(a=> a.id === props.cashFlowMappingToEdit ? result: a))
           
        })
    }
    return (
        <>
        <CustomDialog dialogTitle={props.cashFlowMappingEditMode === FormEditMode.CREATE ? 'Add New Cash Flow Mapping ' : 'Update Cash Flow Mapping '} setOpenDialog={props.setOpenCashFlowMappingForm} openDialog={props.openCashFlowMappingForm}>
            <form>
                <div >
                    <label className='title-label'>Cash Flow Mapping Name <span className='important'>*</span></label>
                </div>
                <div className='col-12'>
                <div className="form-group mb-0">
                        <div className="">
                        <CustomTextField size="small" id="outlined-basic" placeholder="Cash Flow Mapping Name" value={cashFlowMappingName} onChange={(e) => setCashFlowMappingName(e.target.value)} variant="outlined" sx={{width:'100%'}}/> 
                            
                        </div>
                    </div>
                </div>
                <br />
               

                <div className="form-group mt-3 mb-5" style={{ float: 'right' }}>
                    <Button disabled={!cashFlowMappingName} variant="contained" color='secondary' onClick={props.cashFlowMappingEditMode === FormEditMode.CREATE ? createNewCashFlowMapping : updateNewCashFlowMapping} >
                        <Add />&nbsp; {props.cashFlowMappingEditMode === FormEditMode.CREATE ? 'Add New Cash Flow Mapping' : 'Update Cash Flow Mapping'}
                    </Button>
                </div>
            </form >


        </CustomDialog>

    </>
    )
}
export default CreateEditCashFlowMapping